<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">Benefit Option + Benefit Item Mapping</h3>
        </div>
        <div class="col-auto float-right ml-auto">
          <button v-if="!isEdit" class="btn add-btn" @click="isEdit = true">
            <i class="fa fa-edit"></i>Edit
          </button>

          <button
            v-if="isEdit"
            class="btn add-btn"
            style="background-color: #f62d51; border: 1px solid #f62d51"
            @click="cancel"
          >
            <i class="fa fa-close"></i>Cancel
          </button>
          <button v-if="isEdit" class="btn add-btn mr-2" @click="save">
            <i class="fa fa-save"></i>Save
          </button>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Table List -->
    <div class="row">
      <div class="col-md-12">
        <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1">
          <table class="table custom-table mb-0">
            <thead class="thead-light">
              <tr>
                <th class="col-group fixed-column">Group</th>
                <th class="col-benefitoption fixed-column">Benefit Options</th>
                <th v-for="item in benefitItems" :key="item.Id">
                  {{ item.Description }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in benefitOptionItemMapping" :key="i">
                <td
                  class="col-group"
                  :rowspan="item.GroupCount"
                  v-if="
                    i == 0 ||
                    benefitOptionItemMapping[i].Group !=
                      benefitOptionItemMapping[i - 1].Group
                  "
                >
                  {{ item.Group }}
                </td>
                <td class="col-benefitoption">
                  {{ item.BenefitOptionDescription }}
                </td>

                <td
                  v-for="benefitItem in item.BenefitItems"
                  :key="benefitItem.Id"
                >
                  <span v-if="!isEdit">{{ benefitItem.Value }}</span>
                  <template v-else>
                    <textarea
                      v-if="benefitItem.DataType == 'Text'"
                      v-model="benefitItem.Value"
                      class="form-control"
                      maxlength="200"
                    ></textarea>

                    <input
                      v-if="benefitItem.DataType == 'Numeric'"
                      type="number"
                      class="form-control"
                      v-model="benefitItem.Value"
                      step="1"
                      min="1"
                      max="999999"
                    />
                  </template>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- /Table List -->
  </div>
</template>

<script>
import API from "../../http-common.js";
export default {
  data() {
    return {
      benefitOptionItemMapping: [],
      isEdit: false,
    };
  },

  computed: {
    token() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Token;
    },
    role() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Role;
    },
    benefitItems() {
      if (this.benefitOptionItemMapping && this.benefitOptionItemMapping.length)
        return this.benefitOptionItemMapping[0].BenefitItems;
      else return [];
    },
  },

  methods: {
    getBenefitOptionItemMapping() {
      let param = {
        Token: this.token,
      };
      this.$store.state.isLoading = true;
      API.getBenefitOptionItemMapping(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.benefitOptionItemMapping = response.data.record;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    save() {
      let param = {
        Token: this.token,
        BenefitOptionItemMappingArray: this.benefitOptionItemMapping,
      };
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to save the record?",
        icon: "info",
        buttons: true,
        dangerMode: false,
      }).then((willSave) => {
        if (willSave) {
          this.$store.state.isLoading = true;
          API.saveBenefitOptionItemMapping(param)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              if (response.data.success) {
                this.cancel();
              }
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              this.$swal(error.response.data.Message, { icon: "error" });
            });
        }
      });
    },
    cancel() {
      this.isEdit = false;
      this.getBenefitOptionItemMapping();
    },
  },

  created() {
    if (this.role != "admin") {
      this.$router.replace({ name: "home" });
    } else {
      this.getBenefitOptionItemMapping();
    }
  },
};
</script>

<style scoped>
.table-responsive {
  max-height: 584px;
}

.custom-table {
  padding: 0;
  border: 1px solid #dee2e6;
}

.custom-table tr {
  -webkit-box-shadow: none;
  box-shadow: none;
}

thead th {
  top: 0;
  position: sticky;
  position: -webkit-sticky;
  z-index: 20;
}

/* td {
  z-index: 10;
} */

th,
td {
  padding: 0;
  outline: 1px solid #dee2e6;
  border: none;
  outline-offset: -1px;
}

.col-group {
  left: 0;
  position: sticky;
  position: -webkit-sticky;
  background-color: #fff;
}

.col-benefitoption {
  left: 86px;
  position: sticky;
  position: -webkit-sticky;
  background-color: #fff;
}
.fixed-column {
  z-index: 50;
}
</style>


// WEBPACK FOOTER //
// src/components/Benefit/BenefitOptionItemMapping.vue